import React from "react";
import { FacilityOrderTemplateNewFlowCreateTemplate } from "themes/application/facility-order-new-flow/components";
import { observer } from "mobx-react";

@observer
class FacilityOrderTemplateNewFlowCreate extends React.Component {
	render() {
		return <FacilityOrderTemplateNewFlowCreateTemplate {...this.props} />;
	}
}

export default FacilityOrderTemplateNewFlowCreate;